import React from 'react';
import { useDispatch } from 'react-redux';
import Modal from '@saucelabs/ds-modal';
import { modalConnectV2 } from '@saucelabs/sl-container-modal';
import { Typography } from '@saucelabs/ds-typography/lib';
import {
  constants as appStorageConstants,
  records as appStorageRecords,
} from '@saucelabs/sl-module-app-storage';

import constants from '../constants';
import operations from '../operations';

const {
  APP_STORAGE_PRETTY_PLATFORM,
} = appStorageConstants;

type DeleteModalProps = {
  group: appStorageRecords.AppStorageGroup | null;
};

const DeleteModalComponent: React.FC<DeleteModalProps> = ({ group }) => {
  const dispatch = useDispatch();

  return (
    <Modal
      onConfirm={() => {
        if (group) {
          void dispatch(operations.deleteAndRefreshGroups(group));
        }
      }}
      title="Delete App Group"
    >
      {group && (
        <>
          <Typography component="span">Are you sure you want to delete the </Typography>
          <Typography
            className="font-bold"
            component="span"
          >
            {
              APP_STORAGE_PRETTY_PLATFORM[group.recent?.kind]
            }
          </Typography>
          <Typography component="span"> app </Typography>
          <Typography
            className="font-bold"
            component="span"
          >
            {group.name}
          </Typography>
          <Typography component="span"> (Group ID: </Typography>
          <Typography
            className="font-bold"
            component="span"
          >
            {group.id}
          </Typography>
          <Typography component="span">) </Typography>
          <Typography
            component="span"
            data-qa="app-management-group-delete-modal-build-count-label"
          >
            {group.count > 1 ?
              `and its ${group.count} builds?` :
              'and its one build?'}
          </Typography>
        </>
      )}
    </Modal>
  );
};

const DeleteModal = modalConnectV2(
  constants.DELETE_GROUP_MODAL_IDENTIFIER,
  DeleteModalComponent,
);

export default DeleteModal;
export {
  DeleteModalComponent,
};
